import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import { styleSheet } from "./style";
import { withStyles } from "@mui/styles";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AgentCheckOutEquipmentModal from "../modals/checkoutEquipmentModal";
import AgentCheckOutLockBoxModal from "../modals/checkoutLockBoxModal";
import AgentCheckOutSignageModal from "../modals/checkOutSignageModal";
import agentMethodIconWhite from "../../../../assets/images/agents/agentMethodIconWhite.png";
import agentMethodIconBlack from "../../../../assets/images/agents/agentMethodIconBlack.png";
import agentEquipmentIcon from "../../../../assets/images/agents/agentEquipmentIcon.png";
import agentLockIcon from "../../../../assets/images/agents/agentLockIcon.png";
import InventoryItemDetailModal from "../modals/inventoryItemDetailModal";
import InventoryItemDetailEquipmentModal from "../modals/inventoryItemDetailModal1";
import PunchClockIcon from "@mui/icons-material/PunchClock";
import { getAllInventories } from "../../../../redux/inventory";
import { getInventoryLogHistory } from "../../../../redux/agents/agentRosterDetail/inventory/getLogsHistory";
import WidgetsIcon from "@mui/icons-material/Widgets";
import { useSelector, useDispatch } from "react-redux";
import { getAgentInventories } from "../../../../redux/agents/agentRosterDetail/inventory/getAgentInventory";
import { useParams } from "react-router-dom";
import moment from "moment";
import InventorySkelton from "../../../users/skeltons/inventory";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SignageDetailModal from "../modals/signageDetailModal";
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

const AgentInventoryTab = ({ classes }) => {
  const [lockBoxDetail, setLockBoxDetail] = useState({});
  const [equipmentBox, setEquipmentBox] = useState({});
  const [signageDetail, setSignageDetail] = useState({});
  const [openSignageDetail, setOpenSignageDetail] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [openEquipment, setOpenEquipment] = useState(false);
  const [openLockBox, setOpenLockBox] = useState(false);
  const [openItemDetail, setOpenItemDetail] = useState(false);
  const [openItemDetail1, setOpenItemDetail1] = useState(false);
  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 1000,
    search: "",
    status: "available",
    AssetStatus: "available",
  });
  const InventoryList = useSelector(
    (state) => state.inventory.InventoryData.InventoryList
  );
  const inventoryData = useSelector(
    (state) => state.agentRoster.agentInventory.InventoryList
  );
  const logsHistory = useSelector(
    (state) => state.agentRoster.agentInventory.logsHistory
  );
  const { id } = useParams();
  const [openSignageLogsModal, setOpenSignageLogsModal] = useState(false);
  const [openLockboxLogsModal, setOpenLockboxLogsModal] = useState(false);

  useEffect(() => {
    dispatch(getAllInventories(filter));
  }, [filter.search]);

  useEffect(() => {
    dispatch(getAgentInventories({ id: id }));
    dispatch(getInventoryLogHistory({ id: id }));
  }, []);

  const handleOpenDetailMOdal = (data) => {
    let obj = {
      ...data.inventory,
      "check-out": [
        {
          id: data.id,
          signageCount: data.SignageCount,
          transaction_listings_v2: data.transaction_listings_v2,
          users_v2: data?.users_v2,
        },
      ],
    };
    setSignageDetail(obj);
    setOpenSignageDetail(true);
  };

  // Before rendering signage and lockbox logs, sort logsHistory.data by createdAt descending
  const sortedLogs = [...logsHistory.data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item lg={4} xs={12}>
        <div className={classes.inventoryContainer}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 16px 8px 16px' }}>
            <span className={classes.pageHeading} style={{ fontSize: 20, fontWeight: 800, fontFamily: 'Montserrat, Arial, sans-serif' }}>Signage</span>
            <Box display="flex" alignItems="center" gap="11px">
              <IconButton
                onClick={() => setOpen(true)}
                aria-label="add signage"
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <AddCircleIcon sx={{ color: '#000' }} />
              </IconButton>
              <IconButton
                aria-label="logs"
                onClick={() => setOpenSignageLogsModal(true)}
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <ListAltIcon sx={{ color: '#000' }} />
              </IconButton>
            </Box>
          </div>
          <CardContent>
            <Grid container direction="row" spacing={2}>
              {inventoryData?.isLoading ? (
                <Grid item xs={12} sx={{ zIndex: "1" }}>
                  <InventorySkelton />
                </Grid>
              ) : inventoryData?.data?.length > 0 &&
                inventoryData?.data?.filter(
                  (it) => it.inventory?.AssetType === "signage"
                )?.length > 0 ? (
                inventoryData?.data
                  ?.filter((it) => it.inventory?.AssetType === "signage")
                  ?.map((item) => {
                    const signageType = (item?.inventory?.SignageType || '').toLowerCase().replace(/\s/g, '');
                    const isOpenHouse = signageType === 'open_house';
                    const openHouseDay = item.OpenHouseDay ? item.OpenHouseDay.charAt(0).toUpperCase() + item.OpenHouseDay.slice(1).toLowerCase() : '';
                    return (
                      <Grid item xs={12}>
                        <Card
                          onClick={() => handleOpenDetailMOdal(item)}
                          sx={{ cursor: "pointer", borderRadius: "12px", boxShadow: "0px 2px 12px rgba(0,0,0,0.10)", border: "none" }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '12px 16px 12px 12px' }}>
                            <div style={{ marginRight: 12, display: 'flex', alignItems: 'center' }}>
                              <img
                                src={item.SignageColor === "white" ? agentMethodIconWhite : agentMethodIconBlack}
                                alt="agent Method Icon White"
                                style={{ width: 40, height: 40, objectFit: 'contain' }}
                              />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontFamily: 'AvenirNext, Avenir, Arial, sans-serif', fontSize: 18, fontWeight: 500, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {isOpenHouse
                                  ? `OH Signs${openHouseDay ? ' - ' + openHouseDay : ''}`
                                  : 'Directional Signs'}
                              </div>
                              <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontFamily: 'AvenirNext, Avenir, Arial, sans-serif', marginTop: '6px', fontSize: 16, fontWeight: 400, paddingBottom: '4px' }}>
                                <span style={{ background: '#F5F5F5', padding: '1px 6px', borderRadius: 0, fontSize: 13 }}><span style={{ display: 'inline-block', position: 'relative', top: '1px', fontSize: 13, color: '#000' }}>Color: {item.SignageColor ? item.SignageColor.charAt(0).toUpperCase() + item.SignageColor.slice(1).toLowerCase() : ''}</span></span>
                              </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 48 }}>
                              <span style={{
                                fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                                fontSize: 20,
                                fontWeight: 500,
                                color: '#222',
                                background: '#F5F5F5',
                                borderRadius: '50%',
                                width: 36,
                                height: 36,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}>
                                <span style={{ position: 'relative', top: '2px' }}>{item.SignageCount}</span>
                              </span>
                            </div>
                          </div>
                        </Card>
                      </Grid>
                    );
                  })
              ) : (
                <Grid item xs={12} />
              )}
            </Grid>
          </CardContent>
        </div>
      </Grid>
      <Grid item lg={4} xs={12}>
        <div className={classes.inventoryContainer}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 16px 8px 16px' }}>
            <span className={classes.pageHeading} style={{ fontSize: 20, fontWeight: 800, fontFamily: 'Montserrat, Arial, sans-serif' }}>Equipment</span>
            <Box display="flex" alignItems="center" gap="11px">
              <IconButton
                onClick={() => setOpenEquipment(true)}
                aria-label="add equipment"
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <AddCircleIcon sx={{ color: '#000' }} />
              </IconButton>
              <IconButton
                aria-label="logs"
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <ListAltIcon sx={{ color: '#000' }} />
              </IconButton>
            </Box>
          </div>
          <CardContent>
            <Grid container direction="row" spacing={2}>
              {inventoryData?.isLoading ? (
                <Grid item xs={12} sx={{ zIndex: "1" }}>
                  <InventorySkelton />
                </Grid>
              ) : inventoryData?.data?.length > 0 &&
                inventoryData?.data?.filter(
                  (it) => it.inventory?.AssetType === "equipment"
                )?.length > 0 ? (
                inventoryData?.data
                  ?.filter((it) => it.inventory?.AssetType === "equipment")
                  ?.map((item) => (
                    <Grid item xs={12}>
                      <Card
                        sx={{ cursor: "pointer", borderRadius: "12px", boxShadow: "0px 2px 12px rgba(0,0,0,0.10)", border: "none" }}
                        onClick={() => {
                          setOpenItemDetail1(true);
                          setEquipmentBox(item);
                        }}
                      >
                        <CardHeader
                          classes={{
                            title: classes.agentInventoryCardHeader,
                            subheader: classes.agentInventoryCardDes,
                          }}
                          avatar={
                            <img
                              src={agentEquipmentIcon}
                              alt="agent Method Icon White"
                            />
                          }
                          title={<span style={{ fontFamily: 'AvenirNext, Avenir, Arial, sans-serif' }}>{item.inventory?.AssetName}</span>}
                          subheader={<span style={{ fontFamily: 'AvenirNext, Avenir, Arial, sans-serif' }}>{`Serial Number: ${item.inventory?.SerialNumber}`}</span>}
                        />
                      </Card>
                    </Grid>
                  ))
              ) : (
                <Grid item xs={12} />
              )}
            </Grid>
          </CardContent>
        </div>
      </Grid>
      <Grid item lg={4} xs={12}>
        <div className={classes.inventoryContainer}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 16px 8px 16px' }}>
            <span className={classes.pageHeading} style={{ fontSize: 20, fontWeight: 800, fontFamily: 'Montserrat, Arial, sans-serif' }}>Lockboxes</span>
            <Box display="flex" alignItems="center" gap="11px">
              <IconButton
                onClick={() => setOpenLockBox(true)}
                aria-label="add lockbox"
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <AddCircleIcon sx={{ color: '#000' }} />
              </IconButton>
              <IconButton
                aria-label="logs"
                onClick={() => setOpenLockboxLogsModal(true)}
                sx={{
                  background: '#F5F5F5',
                  color: '#000',
                  borderRadius: '8px',
                  width: 40,
                  height: 40,
                  '&:hover': { background: '#E5E5E5' },
                }}
              >
                <ListAltIcon sx={{ color: '#000' }} />
              </IconButton>
            </Box>
          </div>
          <CardContent>
            <Grid container direction="row" spacing={2}>
              {inventoryData?.isLoading ? (
                <Grid item xs={12} sx={{ zIndex: "1" }}>
                  <InventorySkelton />
                </Grid>
              ) : inventoryData?.data?.length > 0 &&
                inventoryData?.data?.filter(
                  (it) => it?.inventory?.AssetType === "lockbox"
                )?.length > 0 ? (
                inventoryData?.data
                  ?.filter((it) => it?.inventory?.AssetType === "lockbox")
                  ?.map((item) => (
                    <Grid item xs={12}>
                      <Card
                        sx={{ cursor: "pointer", borderRadius: "12px", boxShadow: "0px 2px 12px rgba(0,0,0,0.10)", border: "none" }}
                        onClick={() => {
                          setLockBoxDetail(item);
                          setOpenItemDetail(true);
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '12px 16px 12px 12px' }}>
                          <div style={{ marginRight: 12, display: 'flex', alignItems: 'center' }}>
                            <img
                              src={agentLockIcon}
                              alt="agent Method Icon White"
                              style={{ width: 40, height: 40, objectFit: 'contain' }}
                            />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontFamily: 'AvenirNext, Avenir, Arial, sans-serif', fontSize: 18, fontWeight: 500, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {item.inventory?.SerialNumber || item.inventory?.AssetName}
                            </div>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontFamily: 'AvenirNext, Avenir, Arial, sans-serif', marginTop: '6px', fontSize: 16, fontWeight: 400, paddingBottom: '4px' }}>
                              <span style={{ background: '#F5F5F5', padding: '1px 6px', borderRadius: 0, fontSize: 13 }}>
                                <span style={{ display: 'inline-block', position: 'relative', top: '1px', fontSize: 13, color: '#000' }}>
                                  CBS Code: {item.inventory?.CBScode}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* <CardContent classes={{ root: classes.agentInventoryCardContentDes }}>123456 main street longName RD Altana 300033</CardContent> */}
                      </Card>
                    </Grid>
                  ))
              ) : (
                <Grid item xs={12} />
              )}
            </Grid>
          </CardContent>
        </div>
      </Grid>
      {/* Signage Logs Modal */}
      {openSignageLogsModal && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(0,0,0,0.3)',
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => setOpenSignageLogsModal(false)}
        >
          <Box
            sx={{
              width: '90vw',
              maxWidth: 900,
              maxHeight: '100vh',
              height: '69vh',
              bgcolor: '#fff',
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              pt: 2,
              overflow: 'auto',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={e => e.stopPropagation()}
          >
            <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
              <IconButton onClick={() => setOpenSignageLogsModal(false)}
                sx={{ borderRadius: '50%', width: 40, height: 40, '&:hover': { background: '#F5F5F5' } }}
              >
                <span style={{fontSize: 30}}>&times;</span>
              </IconButton>
            </Box>
            <Box sx={{ mt: 0, mb: 2, fontWeight: 500, fontSize: '20px', fontFamily: 'AvenirNext, Avenir, Arial, sans-serif' }}>Signage Logs</Box>
            {/* Signage logs grid (copy from below main cards) */}
            <Box
              sx={{
                borderRadius: "16px",
                background: "#fff",
                p: 0,
                mb: 1,
                border: '1px solid #E0E0E0',
                fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                flex: '1 1 auto',
                height: 'auto',
                overflow: 'auto',
              }}
            >
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                background: '#F7F7F9',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                px: 3,
                py: 1.5,
                fontWeight: 600,
                fontSize: '15px',
                color: '#222',
                fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                position: 'sticky',
                top: 0,
                zIndex: 2,
              }}>
                <Box width={36} sx={{ mr: 2 }}></Box>
                <Box flex={1.2}>Type</Box>
                <Box flex={1}>Color</Box>
                <Box flex={0.8}>Count</Box>
                <Box flex={0.8}>In/Out</Box>
                <Box flex={0.8}>Date</Box>
                <Box flex={1}>Time</Box>
                <Box flex={1.5}>Handled By</Box>
              </Box>
              <Box sx={{ px: 2, py: 1 }}>
                {sortedLogs.filter(item => item.SignageColor || /sign(age)?/i.test(item.Description || '')).map((item, idx) => {
                  const isCheckIn = item.Status?.toLowerCase().includes('in');
                  const occupied = item.inventory_occupied_v2 || {};
                  // For check-in logs, use inventory_occupied_v2 fields
                  const signageColor = isCheckIn ? (occupied.SignageColor || '-') : (item.SignageColor || '-');
                  const openHouseDay = isCheckIn ? (occupied.OpenHouseDay || '') : (item.OpenHouseDay || '');
                  const signageCount = isCheckIn ? (occupied.SignageCount ?? '-') : (item.ItemCount ?? '-');
                  const icon = item.SignageColor === 'white' ? agentMethodIconWhite : agentMethodIconBlack;
                  let checkedOutBy = '';
                  const match = item.Description?.match(/to ([^\n]+) by ([^\n.]+)[. ]?/i) || item.Description?.match(/from ([^\n]+) by ([^\n.]+)[. ]?/i);
                  if (match) checkedOutBy = match[2].trim();
                  return (
                    <Box key={idx} sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#fff',
                      borderRadius: '12px',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
                      my: 1,
                      px: 1,
                      py: 0.75,
                      fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                    }}>
                      <Box width={36} display="flex" justifyContent="center" sx={{ mr: 2 }}>
                        <img src={icon} alt="signage icon" style={{ width: 28, height: 28, objectFit: 'contain' }} />
                      </Box>
                      <Box flex={1.2} sx={{ fontSize: '0.9em' }}>{openHouseDay ? openHouseDay.charAt(0).toUpperCase() + openHouseDay.slice(1) : 'Directional'}</Box>
                      <Box flex={1} sx={{ textTransform: 'capitalize', fontSize: '0.9em' }}>{signageColor}</Box>
                      <Box flex={0.8} sx={{ fontSize: '0.9em' }}>{signageCount}</Box>
                      <Box flex={0.8} sx={{ fontSize: '0.9em' }}>
                        {item.Status?.toLowerCase().includes('in') ? (
                          <Chip label="In" size="small" sx={{ borderRadius: '6px', backgroundColor: '#C8F7C5', color: '#1B5E20', fontWeight: 600 }} />
                        ) : (
                          <Chip label="Out" size="small" sx={{ borderRadius: '6px', backgroundColor: '#FFD699', color: '#B85C00', fontWeight: 600 }} />
                        )}
                      </Box>
                      <Box flex={0.8} sx={{ fontSize: '0.9em' }}>{moment(item.createdAt).format('M/D/YY')}</Box>
                      <Box flex={1} sx={{ fontSize: '0.9em' }}>{moment(item.createdAt).format('LT')}</Box>
                      <Box flex={1.5} display="flex" alignItems="center" sx={{ fontSize: '0.9em' }}>
                        {item.staff ? (
                          <Avatar
                            src={item.staff.profile_images?.profile_img || undefined}
                            alt={item.staff.full_name || ''}
                            sx={{ width: 22, height: 22, mr: 1 }}
                          />
                        ) : (
                          <Avatar sx={{ width: 22, height: 22, mr: 1 }} />
                        )}
                        {item.staff ? (() => {
                          const names = item.staff.full_name.split(' ');
                          return names.length > 1 ? `${names[0]} ${names[names.length - 1][0]}.` : names[0];
                        })() : '-'}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {/* Lockbox Logs Modal */}
      {openLockboxLogsModal && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(0,0,0,0.3)',
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => setOpenLockboxLogsModal(false)}
        >
          <Box
            sx={{
              width: '90vw',
              maxWidth: 900,
              maxHeight: '100vh',
              height: '69vh',
              bgcolor: '#fff',
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              pt: 2,
              overflow: 'auto',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={e => e.stopPropagation()}
          >
            <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
              <IconButton onClick={() => setOpenLockboxLogsModal(false)}
                sx={{ borderRadius: '50%', width: 40, height: 40, '&:hover': { background: '#F5F5F5' } }}
              >
                <span style={{fontSize: 30}}>&times;</span>
              </IconButton>
            </Box>
            <Box sx={{ mt: 0, mb: 2, fontWeight: 500, fontSize: '20px', fontFamily: 'AvenirNext, Avenir, Arial, sans-serif' }}>Lockbox Logs</Box>
            {/* Lockbox logs grid (copy from below main cards) */}
            <Box
              sx={{
                borderRadius: "16px",
                background: "#fff",
                p: 0,
                mb: 1,
                border: '1px solid #E0E0E0',
                fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                flex: '1 1 auto',
                height: 'auto',
                overflow: 'auto',
              }}
            >
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                background: '#F7F7F9',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                px: 3,
                py: 1.5,
                fontWeight: 600,
                fontSize: '15px',
                color: '#222',
                fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                position: 'sticky',
                top: 0,
                zIndex: 2,
              }}>
                <Box width={36} sx={{ mr: 2 }}></Box>
                <Box flex={1.5}>Serial #</Box>
                <Box flex={1.2}>In/Out</Box>
                <Box flex={1.2}>Date</Box>
                <Box flex={1.5}>Time</Box>
                <Box flex={2.2}>Handled By</Box>
              </Box>
              <Box sx={{ px: 2, py: 1 }}>
                {sortedLogs.filter(item => !item.SignageColor && /supra|lockbox|serial/i.test(item.Description || '')).map((item, idx) => {
                  let serial = '';
                  const serialMatch = item.Description?.match(/(Supra|Lockbox)\s*(\w+)/i);
                  if (serialMatch) serial = serialMatch[2];
                  let checkedOutBy = '';
                  const match = item.Description?.match(/to ([^\n]+) by ([^\n.]+)[. ]?/i) || item.Description?.match(/from ([^\n]+) by ([^\n.]+)[. ]?/i);
                  if (match) checkedOutBy = match[2].trim();
                  return (
                    <Box key={idx} sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#fff',
                      borderRadius: '12px',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
                      my: 1,
                      px: 1,
                      py: 0.75,
                      fontFamily: 'AvenirNext, Avenir, Arial, sans-serif',
                    }}>
                      <Box width={36} display="flex" justifyContent="center" sx={{ mr: 2 }}>
                        <img src={agentLockIcon} alt="lockbox icon" style={{ width: 28, height: 28, objectFit: 'contain' }} />
                      </Box>
                      <Box flex={1.5} sx={{ fontSize: '0.9em' }}>{serial || '-'}</Box>
                      <Box flex={1.2} sx={{ fontSize: '0.9em' }}>
                        {item.Status?.toLowerCase().includes('in') ? (
                          <Chip label="In" size="small" sx={{ borderRadius: '6px', backgroundColor: '#C8F7C5', color: '#1B5E20', fontWeight: 600 }} />
                        ) : (
                          <Chip label="Out" size="small" sx={{ borderRadius: '6px', backgroundColor: '#FFD699', color: '#B85C00', fontWeight: 600 }} />
                        )}
                      </Box>
                      <Box flex={1.2} sx={{ fontSize: '0.9em' }}>{moment(item.createdAt).format('M/D/YY')}</Box>
                      <Box flex={1.5} sx={{ fontSize: '0.9em' }}>{moment(item.createdAt).format('LT')}</Box>
                      <Box flex={2.2} display="flex" alignItems="center" sx={{ fontSize: '0.9em' }}>
                        {item.staff ? (
                          <Avatar
                            src={item.staff.profile_images?.profile_img || undefined}
                            alt={item.staff.full_name || ''}
                            sx={{ width: 22, height: 22, mr: 1 }}
                          />
                        ) : (
                          <Avatar sx={{ width: 22, height: 22, mr: 1 }} />
                        )}
                        {item.staff ? (() => {
                          const names = item.staff.full_name.split(' ');
                          return names.length > 1 ? `${names[0]} ${names[names.length - 1][0]}.` : names[0];
                        })() : '-'}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {/* Add modals for add buttons */}
      <AgentCheckOutSignageModal
        open={open}
        InventoryList={InventoryList}
        inventoryData={InventoryList.data?.rows?.filter((item) => item.AssetType === "signage" && item.AssetStatus === "available") || []}
        setOpen={setOpen}
      />
      <AgentCheckOutEquipmentModal
        open={openEquipment}
        setFilter={setFilter}
        filter={filter}
        InventoryList={InventoryList}
        inventoryData={InventoryList.data?.rows?.filter((item) => item.AssetType === "equipment" && item.AssetStatus === "available") || []}
        setOpen={setOpenEquipment}
      />
      <AgentCheckOutLockBoxModal
        open={openLockBox}
        setFilter={setFilter}
        filter={filter}
        InventoryList={InventoryList}
        inventoryData={InventoryList.data?.rows?.filter((item) => item.AssetType === "lockbox" && item.AssetStatus === "available") || []}
        setOpen={setOpenLockBox}
      />
      <InventoryItemDetailModal
        lockBoxDetail={lockBoxDetail}
        IsAgent={true}
        setLockBoxDetail={setLockBoxDetail}
        open={openItemDetail}
        setOpen={setOpenItemDetail}
      />
      <InventoryItemDetailEquipmentModal
        equipmentBox={equipmentBox}
        open={openItemDetail1}
        setOpen={setOpenItemDetail1}
      />
      <SignageDetailModal
        open={openSignageDetail}
        setOpen={setOpenSignageDetail}
        IsAgent={true}
        signageDetail={signageDetail}
      />
    </Grid>
  );
};

export default withStyles(styleSheet)(AgentInventoryTab);